export const CONNECT_WORK_EMAIL = 'CONNECT_WORK_EMAIL';
export const CHECK_INBOX = 'CHECK_INBOX';
export const REQUEST_TO_JOIN = 'REQUEST_TO_JOIN';
export const CREATE_TEAM = 'CREATE_TEAM';
export const SELECT_LOCATION = 'SELECT_LOCATION';
export const SELECT_FLOOR = 'SELECT_FLOOR';
